__turbopack_context__.v({
  "add-to-list-dropdown": "AddToListDropdown-module-scss-module__0Ux0Ta__add-to-list-dropdown",
  "add-to-list-enter": "AddToListDropdown-module-scss-module__0Ux0Ta__add-to-list-enter",
  "center": "AddToListDropdown-module-scss-module__0Ux0Ta__center",
  "create": "AddToListDropdown-module-scss-module__0Ux0Ta__create",
  "create__icon": "AddToListDropdown-module-scss-module__0Ux0Ta__create__icon",
  "create__label": "AddToListDropdown-module-scss-module__0Ux0Ta__create__label",
  "item": "AddToListDropdown-module-scss-module__0Ux0Ta__item",
  "item__indicator": "AddToListDropdown-module-scss-module__0Ux0Ta__item__indicator",
  "item__name": "AddToListDropdown-module-scss-module__0Ux0Ta__item__name",
  "menu": "AddToListDropdown-module-scss-module__0Ux0Ta__menu",
  "popover": "AddToListDropdown-module-scss-module__0Ux0Ta__popover",
  "section": "AddToListDropdown-module-scss-module__0Ux0Ta__section",
  "section__header": "AddToListDropdown-module-scss-module__0Ux0Ta__section__header",
  "trigger": "AddToListDropdown-module-scss-module__0Ux0Ta__trigger",
  "trigger__chevron": "AddToListDropdown-module-scss-module__0Ux0Ta__trigger__chevron",
  "trigger__chevron--open": "AddToListDropdown-module-scss-module__0Ux0Ta__trigger__chevron--open",
  "trigger__icon": "AddToListDropdown-module-scss-module__0Ux0Ta__trigger__icon",
  "trigger__label": "AddToListDropdown-module-scss-module__0Ux0Ta__trigger__label",
  "underlay": "AddToListDropdown-module-scss-module__0Ux0Ta__underlay",
});
